export function compareName<T extends { name: string }>(a: T, b: T): number {
  const aName = (a && a.name) || ''
  const bName = (b && b.name) || ''
  return aName.localeCompare(bName)
}
